<template>
  <div class="pp-content content-wrapper">
    <progress-bar :currentStep="2"></progress-bar>

    <div class="header-request">
      <h3>{{ request.message }}</h3>
    </div>

    <form class="partial-pwd-wrapper" @submit.prevent="sendPartialInstruction">
      <div class="input-block">
        <p>Partial Password</p>
        <div class="pp-input-wrapper">
          <template v-for="(character, index) in options">
            <input
              v-model="password[index]"
              :ref="`input_${index}`"
              :key="index"
              class="input-part-pwd-field"
              type="password"
              :placeholder="character === null ? index + 1 : ''"
              :disabled="character === null"
              name="usrPartialPassword"
              maxlength="1"
              @input="onInput($event, index)"
            />
            <div
              class="pp-separator"
              :key="`sp${index}`"
              v-if="!index || index !== options.length - 1"
            ></div>
          </template>
        </div>

        <proceed-button
          :is-proceed-enable="!!isProceedEnabled"
          :is-loading="isLoading"
        />
      </div>
    </form>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar'
import ProceedButton from '@/components/buttons/ProceedButton'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'PartialPassword',
  components: {
    ProgressBar,
    ProceedButton,
  },
  mixins: [blockBackNavigationMixin],

  props: {
    request: {
      type: Object,
      default: () => {
        // Default value thats populated with the request being sent from backend
      },
    },
  },

  data() {
    return {
      password: this.request.options,
      isLoading: false,
    }
  },

  computed: {
    transactionId() {
      return this.$route.query.transactionId
    },
    options() {
      return this.request.options
    },
    isProceedEnabled() {
      return this.canProceed()
    },
  },

  methods: {
    getNextIndex(startPosition) {
      const index = this.password
        .slice(startPosition)
        .findIndex((character) => character === '')

      return index === -1 ? -1 : index + startPosition
    },
    onInput(event, currentIndex) {
      const isIE = /*@cc_on!@*/ !!document.documentMode
      const isEdge = !!window.StyleMedia
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

      if (isIE || isEdge || isIOS) {
        return
      }

      const next = this.getNextIndex(currentIndex)

      const input = this.$refs[`input_${next}`]
      if (input) {
        input[0].focus()
      }
    },
    canProceed() {
      return !this.password.includes('')
    },
    sendPartialInstruction() {
      if (!this.canProceed()) {
        return
      }

      this.isLoading = true

      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.enteredPartialPassword,
      })
      this.$emit('send-response', {
        messageId: this.request.messageId,
        instruction: this.password,
      })
    },
  },
}
</script>

<style lang="scss">
.pp-content {
  @media screen and (max-width: $mobile-resolution) {
    padding: 16px;
  }
}

.partial-pwd-wrapper {
  display: grid;
  place-items: center;
  margin: 5% 0 5% 0;
}

.pp-input-wrapper {
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  width: 100%;
  border: 1px solid #f1f1f1;
  background: #fff;
  box-shadow: 0px 5px 10px rgba(212, 212, 212, 0.25);
  border-radius: 8px;

  & .input-part-pwd-field {
    display: inline-block;
    flex: 1;
    flex-basis: 18%;
    width: 18%;
    height: 45px;
    text-align: center;
    border: none;
    color: #fff;

    &:disabled {
      color: #484848cc;
      background-color: #f1f1f1;
    }

    &:focus:is(:last-child) {
      border-radius: 0 8px 8px 0;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
    }

    &:focus:is(:first-child) {
      border-radius: 8px 0 0 8px;
    }

    &:first-child {
      border-radius: 8px 0 0 8px;
    }
  }

  & .input-part-pwd-field:not(:disabled) {
    background-color: #299cd0;
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  & .pp-separator {
    &::after {
      content: '';
      display: block;
      position: absolute;
      background: #fff;
      width: 1px;
      height: 40px;
      margin: 2.5px -0.5px;
    }
  }
}
</style>
